import { supabase } from "@/integrations/supabase/client";

export const useTracking = () => {
  const registrar = async (
    tipo: 'view_perfil' | 'click_whatsapp' | 'click_site' | 'click_instagram' | 'click_email' | 'filtro_segmento' | 'busca',
    payload: {
      fornecedor_id?: string;
      segmento_id?: string;
      termo?: string;
      resultados?: number;
    } = {}
  ) => {
    try {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;

      // Fire and forget
      supabase
        .from('eventos')
        .insert({
          tipo,
          user_id: user.id,
          fornecedor_id: payload.fornecedor_id || null,
          segmento_id: payload.segmento_id || null,
          termo: payload.termo || null,
          resultados: payload.resultados ?? null,
        })
        .then(({ error }) => {
          if (error) console.error('Tracking error:', error);
        });
    } catch (e) {
      console.error('Tracking failed:', e);
    }
  };

  return { registrar };
};

